module.exports = __webpack_public_path__ + "media/images/icons/country_flags/km-e45809944f312756023766c865e293a5.svg";